module.exports = __webpack_public_path__ + "img/05.6925bb58.png";